import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      marginButton: theme.spacing(6)
    }
  })
